import { useTranslation } from 'react-i18next';

import useStyles from './styles';
import { IWordCount } from './types';

function WordCount({ showWordCount, numberOfCharacters, numberOfWords }: IWordCount) {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <span className={classes.root}>
      {showWordCount && (
        <>
          {numberOfWords} {t('editor.results.words')}/{numberOfCharacters}{' '}
          {t('editor.results.characters')}
        </>
      )}
    </span>
  );
}
export default WordCount;
